import Page from '../components/Page';
import { useAuth0 } from '@auth0/auth0-react';
import { AppView } from '../constants';
import { ERROR_TYPE, ErrorFallback } from '../components/ErrorFallback';
import { Dialog } from '@mui/material';
import { useLogoutReturnTo } from '../hooks/useLogoutReturnTo';

export const Unauthorized = () => {
  const { logout } = useAuth0();
  const getReturnTo = useLogoutReturnTo();
  return (
    <Page pageName={AppView.UnauthorizedError}>
      <Dialog open fullScreen>
        <ErrorFallback
          type={ERROR_TYPE.UNAUTHORIZED}
          onButtonClick={async () => {
            const returnTo = await getReturnTo();
            logout({ returnTo });
          }}
        />
      </Dialog>
    </Page>
  );
};
